import React, { FunctionComponent } from 'react';

interface Props {
  width?: number;
  height?: number;
}

export const FitbitAvatarBadge: FunctionComponent<Props> = ({
  width = 20,
  height = 20,
}) => {
  return (
    <svg data-qa="fitbit-avatar" width={width} height={height}>
      <circle
        cx="10"
        cy="10"
        r="9"
        fill="#00b0b9"
        stroke="#fff"
        strokeWidth="2"
      />
      <path
        fill="#FFFFFE"
        d="M10.662 4.805a.917.917 0 0 1-.911.911.918.918 0 0 1-.911-.91.92.92 0 0 1 .91-.912.92.92 0 0 1 .912.911zM9.751 6.46a.938.938 0 0 0-.952.954c0 .538.415.953.954.953a.938.938 0 0 0 .951-.953.943.943 0 0 0-.957-.954h.004zm0 2.569c-.537 0-.994.454-.994.993s.457.993.996.993c.536 0 .992-.455.992-.993s-.456-.993-.992-.993H9.75zm0 2.606a.938.938 0 0 0-.952.951c0 .539.415.954.954.954a.938.938 0 0 0 .951-.954.97.97 0 0 0-.957-.95h.004zm0 2.65a.918.918 0 0 0-.911.912c0 .494.414.909.91.909a.918.918 0 0 0 .912-.911.917.917 0 0 0-.911-.91zm2.526-7.948c-.58 0-1.076.499-1.076 1.077 0 .577.496 1.074 1.076 1.074.579 0 1.075-.496 1.075-1.074 0-.579-.496-1.077-1.075-1.077zm0 2.566c-.622 0-1.118.497-1.118 1.119 0 .62.498 1.116 1.118 1.116s1.117-.496 1.117-1.118c0-.62-.496-1.117-1.117-1.117zm0 2.609c-.58 0-1.076.498-1.076 1.074 0 .58.496 1.077 1.076 1.077.579 0 1.075-.499 1.075-1.077s-.496-1.074-1.075-1.074zm2.606-2.733c-.661 0-1.24.54-1.24 1.243 0 .662.537 1.242 1.24 1.242.705 0 1.243-.545 1.243-1.248-.042-.706-.58-1.24-1.243-1.24v.003zM7.184 6.586a.829.829 0 0 0 0 1.656.828.828 0 0 0 0-1.653v-.003zm0 2.567c-.496 0-.87.37-.87.87 0 .496.37.869.866.869a.845.845 0 0 0 .865-.87.85.85 0 0 0-.87-.87h.009zm0 2.605a.828.828 0 0 0 0 1.656.832.832 0 0 0 .827-.833.825.825 0 0 0-.827-.828v.005zM4.62 9.276a.742.742 0 0 0-.746.746c0 .413.33.744.746.744.413 0 .744-.331.744-.744a.741.741 0 0 0-.744-.746z"
      />
    </svg>
  );
};
